import React from 'react'
import '../styles/layout/Home.css'
import { Container } from 'react-bootstrap';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import SavingsOutlinedIcon from '@mui/icons-material/SavingsOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';

/**
 * Transcribed verbatim from `assests/solutions.png`, which carried these five
 * items as baked-in pixels. Same wording, now real text — so it reflows,
 * animates, is selectable and is readable by search engines and assistive tech.
 */
const OUTCOMES = [
  { Icon: AccountBalanceOutlinedIcon, text: 'Acquire new-to-bank customers' },
  { Icon: SavingsOutlinedIcon, text: 'Plug product gaps to defend your current and savings account deposit base' },
  { Icon: TrendingUpOutlinedIcon, text: 'Increase customer touchpoints and profitability' },
  { Icon: AccountBalanceWalletOutlinedIcon, text: 'Help your customers take advantage of an entire payment & personal credit ecosystem' },
  { Icon: InsightsOutlinedIcon, text: 'Enhance the digital experience to customers through mobile solutions, data & analytics' },
]

const Solutions = () => {
  return (
    <section className="solutions section section--defer">
      <span className="section__photo section__photo--flow" data-parallax aria-hidden="true" />
      <Container>
        <h2 className="solutions__title reveal">With 42 Card Solutions, you can</h2>
        <span className="rule reveal" />

        <div className="flow">
          <span className="flow__line" aria-hidden="true" />
          {OUTCOMES.map(({ Icon, text }, i) => (
            <article className="flow__item reveal" key={text} data-delay={i + 1}>
              <span className="flow__dot" aria-hidden="true" />
              <div className="flow__card">
                <span className="flow__icon" aria-hidden="true">
                  <Icon />
                </span>
                <p>{text}</p>
              </div>
            </article>
          ))}
        </div>
      </Container>
    </section>
  )
}

export default Solutions
